<div class="register-success">
  <h2>{{ 'register.success.welcome' | transloco }}</h2>
  <h1>Shutterflow</h1>

  <div class="register-success__card" [@fadeIn]>
    <i class="logo fa-solid fa-camera-retro"></i>
    <p class="plan">{{ planDisplayName() }}</p>
    @if (user) {
      <p class="user">{{user.firstname}} {{user.lastname}}</p>
    }
    <p class="date">{{ now | date: 'dd/MM/yyyy' }}</p>
  </div>

  <button class="button button--large"
    (click)="redirect()"
    >
    {{ 'register.success.discover-now' | transloco }}
    <i class="fa-solid fa-arrow-right"></i>
  </button>
</div>
